import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router-dom';

import { getRegisterUrl } from '@/utils/helpers';

import { Faqs } from './Faqs';
import { FeatureComparator } from './FeatureComparator';
import { Logout } from './Logout';
import { NotFound } from './NotFound';
import { Products } from './Products';
import { Redirect } from './Redirect';
import { Setup } from './Setup';

export const PublicRoutes = () => {
  const { t } = useTranslation();

  return (
    <Routes>
      <Route path="/store">
        <Route path="products" element={<Products />} />
        <Route path="feature-comparator" element={<FeatureComparator />} />
        <Route path="feature-comparator/:lang" element={<FeatureComparator />} />
        <Route path="faqs" element={<Faqs />} />
        <Route path="faqs/:lang" element={<Faqs />} />
        <Route path="*" element={<NotFound />} />
      </Route>
      <Route path="/404" element={<NotFound />} />
      <Route path="/">
        <Route path=":lang" element={<Products />} />
        <Route path="/setup">
          <Route
            path="/setup/hash/:hash/email/:email/service/:service/productname/:productname/productid/:productid/landingname/:landingname/lang/:lang"
            element={<Setup />}
          />
          <Route
            path="/setup/"
            element={<Redirect location={getRegisterUrl(t('ProductsPublicPage.contractPath'))} />}
          />
          <Route
            path="/setup/*"
            element={<Redirect location={getRegisterUrl(t('ProductsPublicPage.contractPath'))} />}
          />
        </Route>
        <Route path="/setup-confirm" element={<Setup />} />
        <Route path="/" element={<Products />} />
        <Route path="/logout.html" element={<Logout />} />
      </Route>
    </Routes>
  );
};
